import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "hideNumberPrefix",
	standalone: false
})
export class HideNumberPrefixPipe implements PipeTransform {
	transform(value: string | number): number {
		return Math.abs(+value);
	}
}
